import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { LK_PUBLICATIONS_ROUTES } from '@/views/LKPublications/utils'
import { HOME_LK_ROUTES as ROUTES } from './utils'
import { lkStoreModule } from '@/store/modules/lk'

type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

const createRoutes = (options: Options): RouteConfig[] => [
  {
    async beforeEnter(to, from, next) {
      const storeModule = lkStoreModule.context(options.store)
      if (storeModule.getters.authorized) {
        next({ name: LK_PUBLICATIONS_ROUTES.LAYOUT })
        return
      }

      await storeModule.actions.getTopics().catch(() => ({}))
      next()
    },
    path: '/',
    name: ROUTES.LAYOUT,
    component: (): PromiseVue => import(
      /* webpackChunkName: "lk-publications.list" */
      './LkHomeIndex.vue'
    ),
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
